import { render, staticRenderFns } from "./touxi.vue?vue&type=template&id=2f5d64b3&scoped=true&"
import script from "./touxi.vue?vue&type=script&lang=js&"
export * from "./touxi.vue?vue&type=script&lang=js&"
import style0 from "./touxi.vue?vue&type=style&index=0&id=2f5d64b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d64b3",
  null
  
)

export default component.exports